import type { ClientGlobals } from './types'
import makeObjectPropertiesReadOnly from './makeObjectPropertiesReadOnly'

export const freezeClientGlobals = (isSecurityHardeningsEnabled: boolean) => {
	let globalMethodsToFreeze: Array<ClientGlobals> = []
	let globalObjectsToFreeze: Array<ClientGlobals> = []

	globalObjectsToFreeze = globalObjectsToFreeze.concat(['TextEncoder', 'TextDecoder'])

	if (isSecurityHardeningsEnabled) {
		globalObjectsToFreeze = globalObjectsToFreeze.concat(['XMLHttpRequestEventTarget', 'EventTarget'])
	}

	globalObjectsToFreeze = globalObjectsToFreeze.concat(['URL', 'JSON'])

	if (isSecurityHardeningsEnabled) {
		globalMethodsToFreeze = globalMethodsToFreeze.concat(['addEventListener', 'removeEventListener'])
	}

	globalMethodsToFreeze = globalMethodsToFreeze.concat([
		'encodeURI',
		'encodeURIComponent',
		'decodeURI',
		'decodeURIComponent',
	])

	globalObjectsToFreeze = globalObjectsToFreeze.concat(['String', 'Number'])

	if (isSecurityHardeningsEnabled) {
		globalObjectsToFreeze.push('Object')
	}

	globalObjectsToFreeze = globalObjectsToFreeze.concat(['Reflect'])

	globalMethodsToFreeze.forEach((key) => {
		// Freeze the object
		Object.freeze(globalThis[key])

		if (['addEventListener', 'removeEventListener'].includes(key)) {
			// @ts-expect-error
			globalThis.defineStrictProperty(key, document[key], document, true)
		}

		// @ts-expect-error
		globalThis.defineStrictProperty(key, globalThis[key], globalThis, true)
	})

	globalObjectsToFreeze.forEach((key) => {
		/**
		 * We are freezing objects in a specific way for the following reasons:
		 * 1. Object.freeze does not allow extending the object with new properties.
		 * 2. Freezing Object.prototype can prevent changes to the prototype chain, including property additions or
		 * 		modifications. When Object.prototype is frozen, attempts to set properties on objects that inherit from it
		 * 		can lead to unexpected behavior.
		 * 		For more details, see: https://esdiscuss.org/topic/set-and-inherited-readonly-data-properties
		 */
		makeObjectPropertiesReadOnly(key, globalThis)
	})
}
